import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../external/account/shared/services/account.service';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';
import { TechVendor, TechBuyer } from "../external/account/shared/models/account.models";
import swal from 'sweetalert2';
import { SsoLoginService } from '@app/shared/services/sso-login.service';
import { Title } from '@angular/platform-browser';
declare var window: any;

@Component({
  selector: 'app-sso-signup-response',
  templateUrl: './sso-signup-response.component.html',
  styleUrls: ['./sso-signup-response.component.css'],
  providers: [AccountService]
})
export class SsoSignupResponseComponent implements OnInit {
  techVendor = new TechVendor();
  techBuyer = new TechBuyer();
  buttonValidate: boolean;
  phoneNumber = "";
  inviteToken: string;
  countryDialCode = "65";
  modeOfRegistration = "Email";
  via = "Direct";
  role: any;
  userRoleInfo: any;
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    private ssoService: SsoLoginService,
    private titleService: Title,
    private mixpanelEventLoggingService: MixpanelEventLoggingService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
         this.ssoService.currentUserRoleSourceValue.subscribe(
          (value: any) => {
            console.log('currentUserRoleSourceValue==', value);
            this.role = value;
          },
          error => {
            console.log('error==', error);
          });
          if (!this.role && window.localStorage.getItem("ssoUserType")) {
            this.role = window.localStorage.getItem('ssoUserType');
          }
          if (this.role === 'tech_buyer') {
            this.userRoleInfo = this.techBuyer;
          } else {
           this.userRoleInfo = this.techVendor;
          }
          let userInfo = [];
          var decodedString = atob(params['param1']);
          userInfo = JSON.parse(decodedString);
          console.log("params['param1'][2]===", userInfo['emailaddress']);
      this.userRoleInfo.salutationId = "216B941C-07A0-F048-8F38-8072CD8AE793";
      this.userRoleInfo.firstName = userInfo['firstName'];
      this.userRoleInfo.middleName = "";
      this.userRoleInfo.lastName = userInfo['lastName'];
      this.userRoleInfo.email = userInfo['emailaddress'];
      this.userRoleInfo.countryId = "";
      this.userRoleInfo.organizationName = 'IBM';
      this.userRoleInfo.password = "EcoSSO@123";
      this.userRoleInfo.roleCode = this.role;
      this.userRoleInfo.emailVerified = true;
      if (this.inviteToken) {
        this.userRoleInfo['inviteToken'] = this.inviteToken;
        this.userRoleInfo['isInvited'] = true;
      }

      if (this.phoneNumber === "") {
        this.userRoleInfo.phoneNumber = "";

      } else {
        this.userRoleInfo.phoneNumber =
          "+" +
          this.countryDialCode +
          " " +
          this.phoneNumber.replace("+" + this.countryDialCode, "");
      }

      this.buttonValidate = false;
      this.accountService.registerUser(this.userRoleInfo).subscribe(
        (data: any) => {


         // window.sessionStorage.setItem("user_role", "tech_buyer");
          const resetData = {
            email: data.email,
            otpMethod: "mobile",
            phoneNumber: data.phoneNumber
          };

          let  _hsq = window._hsq = window._hsq || [];
          _hsq.push(["identify",{
            email: ( data!= null) ? data.email: '',
          }]);
          _hsq.push(['trackPageView']);
          _hsq.push(['refreshPageHandlers']);

          this.titleService.setTitle('User register' +  data.email);
        
           _hsq.push(["trackEvent", {
            id: data.email,
            value :'User has been register successfully from subscription: '
            }]); 
          _hsq.push(['trackPageView'])
          _hsq.push(['refreshPageHandlers']);


          this.mixpanelEventLoggingService.dispatchEvent("signup", {
            ModeofRegistration: this.modeOfRegistration,
            Device: "Web",
            Via: this.via,
            EmailID: data.email,
            UserRole: this.role
          });
          window.sessionStorage.setItem("resetData", JSON.stringify(resetData));
          if (data.phoneNumber === "") {
            this.router.navigate(['/sso'], { queryParams: { param1: params['param1'] } });
          } else if (data.phoneNumber !== "") {
            window.sessionStorage.setItem(
              "resetData",
              JSON.stringify(resetData)
            );
            this.router.navigate(['/sso'], { queryParams: { param1: params['param1'] } });
          }
        },
        error => {
          swal("Info", error.error.error.message, "info");
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/sso-signup-response/sso-signup-response.component.ts